"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CurrentLocation = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const CurrentLocation = exports.CurrentLocation = (0, _mui.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8",
    opacity: "0.6",
    fill: "#E7F7F1"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "3.46"
  })]
}), 'CurrentLocation');
var _default = exports.default = CurrentLocation;